import { GenericModal } from "components/modals/GenericModal";
import { ModalProps } from "components/types/ModalProps";
import { FC } from "react";
import { accountLiterals } from "./literals";
import CtaSecondary from "components/CtaSecondary";
import QRCode from "react-qr-code";
import { useCustomWallet } from "components/providers";

type Props = ModalProps & {};

const { backButton, subheader, title } = accountLiterals.qrModal;

export const ModalQr: FC<Props> = (props) => {
  const { isOpen, toggleModal } = props;
  const { smartAddress } = useCustomWallet();

  const handleBack = () => toggleModal();

  return (
    <GenericModal
      className="pt-[30px] pr-[30px] pl-[30px] pb-[30px]"
      isOpen={isOpen}
      toggleModal={toggleModal}
      headerTitle={title}
      headerSubtitle={subheader}
    >
      <div className="mt-[30px] border border-white border-opacity-50 rounded-2xl p-4 flex items-center justify-center">
        {smartAddress && (
          <QRCode
            value={smartAddress}
            bgColor="transparent"
            fgColor="#FFCE16"
          />
        )}
      </div>
      <CtaSecondary
        type="button"
        className="mt-[30px] w-40"
        onClick={handleBack}
      >
        {backButton}
      </CtaSecondary>
    </GenericModal>
  );
};
